import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Link, Stack, TextField, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EvaluationListItem } from "./EvaluationListItem";
import { returnIsValid } from "../Main/useConstants";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";

// Lista de acciones o politicas
export const EvaluationList = ({
  id,
  data,
  questionLabel,
  questionTitle,
  helpText = "",
  switchh,
  setSwitch,
  newItemError,
  errors,
  triedToSave,
  handleChangeList,
  handleChangueDetailsList,
  handleDeleteFromList,
  handleAddToList,
  setOutsideValue = () => {},
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const [newItemValue, setNewItemValue] = useState("");
  const [newItemDetails, setNewItemDetails] = useState("");
  const [newItemActiveDetails, setNewItemActiveDetails] = useState(false);

  useEffect(() => {
    setOutsideValue({ value: newItemValue, details: newItemDetails });
  }, [newItemValue, newItemDetails]);

  const handleAdd = () => {
    handleAddToList(id, { value: newItemValue, details: newItemDetails });
    setNewItemValue("");
    setNewItemDetails("");
    setNewItemActiveDetails(false);
  }

  const isDisabled = newItemValue.length === 0;

  return (
    <>
      
      <Stack direction="row" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography fontSize={16} fontWeight={600} color="secondary">
            {questionTitle}
          </Typography>
          <HelpIcon text={helpText} sx={{ marginLeft: .5 }} />
        </Box>
        <EGSwitch
          checked={switchh}
          onChange={() => setSwitch(prev=>({...prev, [id]: !prev[id]}))}
          id="locked"
          size="small"
        />
      </Stack>
      
      {
        switchh &&
        <Stack spacing={1.5}>
          {
            data.length > 0 &&
            data.map((item, idx) => (
              <EvaluationListItem
                key={idx}
                idx={idx}
                id={id}
                questionLabel={questionLabel}
                item={item}
                handleChange={handleChangeList}
                handleChangueDetails={handleChangueDetailsList}
                handleDeleteFromList={handleDeleteFromList}
                errors={Array.isArray(errors) ? errors.includes(idx) : false}
                triedToSave={triedToSave}
              />
            ))
          }
          <Box display="grid" gridTemplateColumns="1fr 48px" alignItems="center" justifyItems="center" >
            <EGInput
              label={questionLabel}
              value={newItemValue}
              onChange={(e) => setNewItemValue(e.target.value)}
              required={true}
              isValid={data.length > 0 ? null : returnIsValid(newItemError, triedToSave)}
              showSuccessValidation={true}
              showHelpText={false}
            />
            <EGIconButton
              title={t("Añadir")}
              iconName="add_square"
              iconColor={"ethicsBlue"}
              placement="bottom"
              onClick={isDisabled ? () => {} : handleAdd}
              iconSize={16}
              disabled={isDisabled}
            />
            {
              !newItemActiveDetails &&
              <Link
                onClick={() => setNewItemActiveDetails(true)}
                underline="hover"
                textAlign="end"
                marginTop="3px"
                sx={{ justifySelf: "end" }}
              >
                + {t("evaluation.add_details")}
              </Link>
            }
          </Box>
          {
            newItemActiveDetails && 
            <TextField
              label={t("evaluation.details")}
              value={newItemDetails}
              onChange={(e)=>setNewItemDetails(e.target.value)}
              multiline
              rows={4}
              className="w-100"
            />
          }

        </Stack>
      }

    </>
  )
}